export default "__VITE_ASSET__DWBJEgom__"